import React, { FunctionComponent } from 'react';
import "./error.scss"
import Text from '../../components/typography/typgraphy';
import Ibicon from '../../assets/images/ibError.png'


const LoginError = () => {
  return (
    <div className="common-error-container">
      <div className="error-wrapper">
        <div className="error-description-container">
          <img className="error-icon" src={Ibicon} alt="error" />
          <Text className="error-heading">Uh Oh!</Text>
          <Text className="error-sub-heading">We are Sorry!</Text>
          <Text className="error-description">Something went wrong!</Text>
          <Text className="error-description">Please re initiate the transaction from partner portal and try again.</Text>
        </div>
      </div>
    </div>
  )
}

export default LoginError;
